import * as React from 'react';
import { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface SectionHeaderProps {
  subtitle?: string;
  title: ReactNode;
  description: ReactNode;
}

export const SectionHeader = ({
  subtitle,
  title,
  description,
}: SectionHeaderProps) => {
  return (
    <>
      {subtitle && (
        <h2 className="text-base/7 font-semibold text-primary">Type Safety</h2>
      )}
      <p
        className={cn(
          'text-4xl font-bold tracking-tight text-pretty sm:text-5xl',
          {
            'mt-2': !!subtitle,
          },
        )}
      >
        {title}
      </p>
      <p className="mt-6 text-lg/8 text-muted-foreground">{description}</p>
    </>
  );
};
